(function () {
  var DEFAULT_CAPTIONS = [
    "Today's session recap",
    "Yesterday's session recap",
    "Day before session recap",
  ];
  var DEFAULT_LABELS = ["TODAY'S RECAP", "YESTERDAY", "DAY BEFORE", "SESSION RECAP"];

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function isReelPost(post) {
    if (!post) return false;
    if (post.isReel === true) return true;
    if (post.mediaType === "VIDEO") return true;
    return /\/reel\//i.test(post.permalink || "");
  }

  function isGraphReel(post) {
    if (!post) return false;
    var type = post.media_type || "";
    return type === "VIDEO" || type === "REELS";
  }

  function posterFromPost(post) {
    return (
      (post.sizes && post.sizes.medium && post.sizes.medium.mediaUrl) ||
      post.thumbnailUrl ||
      (post.mediaType !== "VIDEO" ? post.mediaUrl : "") ||
      ""
    );
  }

  function mapBeholdPost(post) {
      var isVideo = post.mediaType === "VIDEO";
      var posterUrl = posterFromPost(post);
      return {
        url: post.permalink || "",
        imageUrl: isVideo ? posterUrl : posterUrl,
        videoUrl: isVideo ? post.mediaUrl || "" : "",
        posterUrl: posterUrl,
        caption: post.prunedCaption || post.caption || "",
        alt: post.altText || post.prunedCaption || post.caption || "Instagram reel",
        isVideo: isVideo,
      };
  }

  function pickBeholdPosts(payload, limit, reelsOnly) {
    var posts = (payload && payload.posts) || [];
    if (!posts.length) return [];

    var reels = posts.filter(isReelPost);
    var picked = reels.slice(0, limit).map(mapBeholdPost);

    if (picked.length >= limit || !reelsOnly) {
      if (picked.length) return picked;
      return posts.slice(0, limit).map(mapBeholdPost);
    }

    var usedUrls = {};
    picked.forEach(function (post) {
      if (post.url) usedUrls[post.url] = true;
    });

    posts.forEach(function (post) {
      if (picked.length >= limit) return;
      if (isReelPost(post)) return;
      var mapped = mapBeholdPost(post);
      if (mapped.url && usedUrls[mapped.url]) return;
      picked.push(mapped);
      if (mapped.url) usedUrls[mapped.url] = true;
    });

    return picked;
  }

  function mergePostLists(primary, extra, limit) {
    var merged = primary.slice();
    var usedUrls = {};
    merged.forEach(function (post) {
      if (post.url) usedUrls[post.url] = true;
    });

    extra.forEach(function (post) {
      if (merged.length >= limit) return;
      if (post.url && usedUrls[post.url]) return;
      merged.push(post);
      if (post.url) usedUrls[post.url] = true;
    });

    return merged.slice(0, limit);
  }

  function loadBeholdPosts(beholdUrl, supplementUrl, limit, reelsOnly) {
    return fetchBeholdFeed(beholdUrl).then(function (primaryPayload) {
      var posts = pickBeholdPosts(primaryPayload, limit, reelsOnly);
      if (posts.length >= limit || !supplementUrl) return posts;

      return fetchBeholdFeed(supplementUrl)
        .then(function (supplementPayload) {
          var extra = pickBeholdPosts(supplementPayload, limit, false);
          return mergePostLists(posts, extra, limit);
        })
        .catch(function () {
          return posts;
        });
    });
  }

  function mapGraphPost(post) {
      var isVideo = post.media_type === "VIDEO" || post.media_type === "REELS";
      var posterUrl = post.thumbnail_url || post.media_url || "";
      return {
        url: post.permalink || "",
        imageUrl: posterUrl,
        videoUrl: isVideo ? post.media_url || "" : "",
        posterUrl: posterUrl,
        caption: post.caption || "",
        alt: post.caption || "Instagram reel",
        isVideo: isVideo,
      };
  }

  function pickGraphPosts(payload, limit, reelsOnly) {
    var posts = (payload && payload.data) || [];
    if (!posts.length) return [];

    if (reelsOnly) {
      var reels = posts.filter(isGraphReel);
      if (reels.length) return reels.slice(0, limit).map(mapGraphPost);
    }

    return posts.slice(0, limit).map(mapGraphPost);
  }

  function readFallbackCaptions(scroll) {
    var script = scroll.querySelector("[data-ig-fallback-captions]");
    if (!script) return [];

    try {
      var parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function fetchBeholdFeed(url) {
    return fetch(url, { credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("Behold feed unavailable");
      return response.json();
    });
  }

  function fetchGraphFeed(userId, token, limit) {
    var fields = "id,caption,media_type,media_url,thumbnail_url,permalink,timestamp";
    var fetchLimit = Math.max(limit * 4, 12);
    var endpoint =
      "https://graph.instagram.com/" +
      encodeURIComponent(userId) +
      "/media?fields=" +
      encodeURIComponent(fields) +
      "&limit=" +
      encodeURIComponent(String(fetchLimit)) +
      "&access_token=" +
      encodeURIComponent(token);

    return fetch(endpoint, { credentials: "omit" }).then(function (response) {
      if (!response.ok) throw new Error("Instagram Graph API unavailable");
      return response.json();
    });
  }

  function buildPlaceholderSvg(label) {
    return (
      '<span class="home-instagram__placeholder">' +
      '<svg viewBox="0 0 200 280" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      '<text x="12" y="28" fill="#C8102E" font-size="11" font-weight="700" letter-spacing="1.4" font-family="Arial, sans-serif">' +
      escapeHtml(label) +
      "</text>" +
      '<polyline points="12,210 40,190 62,200 88,150 112,165 138,110 162,128 188,78" fill="none" stroke="#C8102E" stroke-width="3"/>' +
      '<rect x="36" y="168" width="10" height="32" fill="#C8102E" opacity="0.85"/>' +
      '<rect x="84" y="128" width="10" height="40" fill="#C8102E" opacity="0.85"/>' +
      '<rect x="134" y="96" width="10" height="36" fill="#888" opacity="0.7"/>' +
      '<rect x="158" y="70" width="10" height="44" fill="#C8102E"/>' +
      "</svg></span>"
    );
  }

  function buildMedia(post, label) {
    if (post.videoUrl) {
      return (
        '<video class="home-instagram__video" ' +
        'poster="' +
        escapeHtml(post.posterUrl || post.imageUrl || "") +
        '" ' +
        'src="' +
        escapeHtml(post.videoUrl) +
        '" ' +
        'muted playsinline loop preload="metadata" aria-label="' +
        escapeHtml(post.alt || "Instagram reel") +
        '"></video>'
      );
    }

    if (post.imageUrl) {
      return (
        '<img src="' +
        escapeHtml(post.imageUrl) +
        '" alt="' +
        escapeHtml(post.alt || "Instagram post") +
        '" loading="lazy" width="600" height="1067">'
      );
    }

    return buildPlaceholderSvg(label);
  }

  function initVideoPlayback(grid) {
    var videos = grid.querySelectorAll(".home-instagram__video");
    if (!videos.length) return;

    function playVideo(video) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {
          /* Autoplay blocked until user interaction — poster still shows */
        });
      }
      var postEl = video.closest(".home-instagram__post");
      if (postEl) postEl.classList.add("home-instagram__post--playing");
    }

    function pauseVideo(video) {
      video.pause();
      var postEl = video.closest(".home-instagram__post");
      if (postEl) postEl.classList.remove("home-instagram__post--playing");
    }

    if ("IntersectionObserver" in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
              playVideo(video);
            } else {
              pauseVideo(video);
            }
          });
        },
        { threshold: [0, 0.45, 0.75] }
      );

      videos.forEach(function (video) {
        observer.observe(video);
      });
      return;
    }

    videos.forEach(playVideo);
  }

  function renderPosts(grid, posts, config) {
    var profile = config.profile || "https://www.instagram.com/redboxanalysis/";
    var html = posts
      .map(function (post, index) {
        var fallbackCaption = config.fallbackCaptions[index] || DEFAULT_CAPTIONS[index] || DEFAULT_CAPTIONS[0];
        var caption = post.caption ? post.caption.split("\n")[0].trim() : fallbackCaption;
        if (caption.length > 72) caption = caption.slice(0, 69) + "…";
        var label = DEFAULT_LABELS[index] || DEFAULT_LABELS[DEFAULT_LABELS.length - 1];
        var href = post.url || profile;
        var postClass = "home-instagram__post" + (post.videoUrl ? " home-instagram__post--video" : "");

        return (
          '<a href="' +
          escapeHtml(href) +
          '" target="_blank" rel="noopener" class="' +
          postClass +
          '" data-animate="fade-up">' +
          buildMedia(post, label) +
          '<span class="home-instagram__play" aria-hidden="true">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"></line></svg>' +
          "</span>" +
          '<span class="home-instagram__caption">' +
          escapeHtml(caption) +
          "</span>" +
          "</a>"
        );
      })
      .join("");

    grid.innerHTML = html;
    grid.setAttribute("data-ig-loaded", "true");
    initVideoPlayback(grid);
  }

  function initSection(root) {
    var scroll = root.querySelector("[data-ig-live-feed]");
    var grid = root.querySelector("[data-ig-grid]");
    if (!scroll || !grid) return;

    var useLive = scroll.dataset.useLive === "true";
    var beholdUrl = (scroll.dataset.beholdUrl || "").trim();
    var supplementUrl = (scroll.dataset.beholdSupplementUrl || "").trim();
    var graphUser = (scroll.dataset.graphUser || "").trim();
    var graphToken = (scroll.dataset.graphToken || "").trim();
    var limit = parseInt(scroll.dataset.postCount || "3", 10);
    var reelsOnly = scroll.dataset.reelsOnly !== "false";
    var fallbackCaptions = readFallbackCaptions(scroll);

    if (!useLive || (!beholdUrl && !(graphUser && graphToken))) return;

    grid.classList.add("home-instagram__grid--loading");

    var loader = beholdUrl
      ? loadBeholdPosts(beholdUrl, supplementUrl, limit, reelsOnly)
      : fetchGraphFeed(graphUser, graphToken, limit).then(function (payload) {
          return pickGraphPosts(payload, limit, reelsOnly);
        });

    loader
      .then(function (posts) {
        if (!posts.length) throw new Error("No Instagram posts returned");
        renderPosts(grid, posts, {
          profile: scroll.dataset.profile,
          fallbackCaptions: fallbackCaptions,
        });
      })
      .catch(function () {
        var captions = fallbackCaptions.length ? fallbackCaptions : DEFAULT_CAPTIONS;
        var fallbackPosts = captions.slice(0, limit).map(function (caption) {
          return {
            url: scroll.dataset.profile || "https://www.instagram.com/redboxanalysis/",
            imageUrl: "",
            videoUrl: "",
            posterUrl: "",
            caption: caption,
            alt: caption,
            isVideo: false,
          };
        });
        renderPosts(grid, fallbackPosts, {
          profile: scroll.dataset.profile,
          fallbackCaptions: captions,
        });
      })
      .finally(function () {
        grid.classList.remove("home-instagram__grid--loading");
        root.dispatchEvent(new CustomEvent("home-instagram:loaded"));
      });
  }

  function initAll() {
    document.querySelectorAll(".home-instagram[data-ig-section]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
